import { createContext, JSX, ReactNode, useContext } from 'react';
import * as vp from 'vopay';

const { useDatadog } = vp;
export type DatadogCtx = {
  setUser: (requestParams: { [id: string]: string }) => void;
  clearUser: () => void;
  logMessage: (message: string, type: 'info' | 'warn' | 'error', context: object) => void;
};

export const DatadogContext = createContext<DatadogCtx>({
  setUser: () => {},
  clearUser: () => {},
  logMessage: () => {},
});

export const DatadogProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const site = import.meta.env.VITE_DDOG_SITE;
  const env = import.meta.env.VITE_DDOG_ENV;
  const clientToken = import.meta.env.VITE_DDOG_CLIENTTOKEN;
  const service = import.meta.env.VITE_DDOG_SERVICE;
  const applicationId = import.meta.env.VITE_DDOG_APPLICATIONID;
  const version = import.meta.env.VITE_DDOG_VERSION;

  const [setUser, clearUser, , logMessage] = useDatadog({
    site,
    env,
    clientToken,
    service,
    applicationId,
    version,
  });

  return (
    <DatadogContext.Provider
      value={{
        setUser,
        clearUser,
        logMessage,
      }}
    >
      {children}
    </DatadogContext.Provider>
  );
};

export const useDataDog = (): DatadogCtx => useContext(DatadogContext);
